import axios from '../../config/axios';
import getEnv from '../getEnv';

const context = getEnv('usuario');

export default {
  sendEmailChangePassword: async email => {
    let data;
    try {
      const response = await axios.get(
        `${context}/users/sendemailchangepassword/${email}`,
      );

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  changePassword: async payload => {
    const { password, confirmPassword, token } = payload;

    let data;
    try {
      const response = await axios.patch(
        `${context}/users/changepassword/${token}`,
        {
          password,
          confirmPassword,
        },
      );

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  validateToken: async token => {
    let data;
    try {
      const response = await axios.get(`${context}/users/validtoken/${token}`);

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  resendEmailAuthentication: async email => {
    let data;
    try {
      const response = await axios.get(
        `${context}/users/resendemailauthentication/${email}`,
      );

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  sendEmailUnlockUser: async email => {
    let data;
    try {
      const response = await axios.get(
        `${context}/users/sendemailtounlockuser/${email}`,
      );

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  checkStatusToken: async token => {
    let data;
    try {
      const response = await axios.get(
        `${context}/users/checkstatustoken/${token}`,
      );
      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  register: async data => {
    return axios.post(`${context}/users`, data);
  },
  edit: async data => {
    return axios.put(`${context}/users/update/`, data);
  },
  get: async () => {
    const response = await axios.get(`${context}/users/finduser/`);
    return response.data.result;
  },
  findEmailByCpf: async cpf => {
    let data;
    try {
      const response = await axios.get(
        `${context}/users/findemailbycpf/${cpf}`,
      );

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  changeAccessData: async payload => {
    const { password, confirmPassword, currentPassword } = payload;

    let data;
    try {
      const response = await axios.put(`${context}/users/changeaccessdata`, {
        password,
        confirmPassword,
        currentPassword,
      });

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  getNotifications: async () => {
    const response = await axios.get(
      `${context}/notifications/findnotifications`,
    );
    return response.data.result;
  },
  getPromotions: async productId => {
    const response = await axios.get(
      `${context}/notifications/findpromotion?idProduto=${productId}`,
    );
    return (
      (response.data.result &&
        response.data.result[0] &&
        response.data.result[0].lista) ||
      []
    );
  },
  getNotificationData: async id => {
    const response = await axios.get(
      `${context}/notifications/datapromotion?id=${id}`,
    );
    return response.data.result;
  },
  getNewNotifications: async () => {
    const response = await axios.get(`${context}/notifications/bellinfo`);
    return response.data.result;
  },
  device: async (cpf, email, token) => {
    try {
      const response = await axios.post(`${context}/device`, {
        cpf,
        email,
        token,
      });

      return response?.data?.result;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }
  },
  cookieConsent: async () => {
    let data;

    try {
      const response = await axios.post(`${context}/users/cookieconsent`);
      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  findProfile: async () => {
    let data;

    try {
      const response = await axios.get(`${context}/users/findprofile`);

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  updateTermsAndPolicy: async status => {
    try {
      await axios.put(`${context}/terms`, {
        statusTermsUse: status,
      });
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }
  },
};
